export const convertMapWithMainKeyToString = (val: any, mainKey: string) => {
  if (val === null || typeof val !== "object") {
    return "-";
  }
  const result = [];
  // Include the mainKey first if it's not empty
  if (mainKey && mainKey in val) {
    result.push(`${mainKey}: ${val[mainKey]}`);
  }
  // Iterate through the rest of the keys, excluding mainKey
  Object.entries(val).forEach(([key, value]) => {
    if (key !== mainKey) {
      result.push(`${key}: ${value}`);
    }
  });
  // Join the result array with commas and return
  return result.length > 0 ? result.join(", ") : "-";
};
